'use client';

import Script from 'next/script';
import React from 'react';
import * as fbq from '@/utils/facebookPixel';
import { usePathname, useSearchParams } from 'next/navigation';

const FacebookPixel: React.FC = () => {
  const pathname = usePathname();
  const searchParms = useSearchParams();

  React.useEffect(() => {
    // Initialize both pixels and send pageview
    fbq.initFacebookPixel();
  }, [pathname, searchParms]);

  return (
    <>
      <Script
        id="fb-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          `,
        }}
      />
    </>
  );
};

export default FacebookPixel;
